module.exports = __webpack_public_path__ + "img/windtre_logotype_negative.fb36064b.svg";